import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Form, Row, Col, Button, Alert } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";
const EditPayments = () => {
  const initialStage = {
    vfcId: "",
    accountId: "",
    voucherType: "",
    voucherNumber: "",
    partyDetails: "",
    amount: "",
    description: "",
    cashOrBank: "",
    date: "",
  };

  const Api = process.env.REACT_APP_API;
  const [vfcOptions, setVfcOptions] = useState([]);
  const [formData, setFormData] = useState(initialStage);
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [accountOptions, setAccountOptions] = useState([]);
  const [voucherOptions, setVoucherOptions] = useState([]);

  useEffect(() => {
    setLoading(true);
    const fetchVfcs = async () => {
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, Config);
        const data = response.data.vfcs;

        if (Array.isArray(data)) {
          setVfcOptions(data);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };

    fetchVfcs();
  }, [Api]);
  useEffect(() => {
    const fetchVoucherTypes = async () => {
      try {
        const Config = Authorization();
        const response = await fetch(
          `${Api}/api/voucher-type-mappings`,
          Config
        );
        const data = await response.json();
        setVoucherOptions(data.voucherTypeMappings);
      } catch (error) {
        console.log("Error fetching Voucher Types", error);
      }
      setLoading(false);
    };

    const fetchAccounts = async () => {
      try {
        const Config = Authorization();
        const response = await fetch(`${Api}/api/accounts`, Config);
        const data = await response.json();
        setAccountOptions(data.data);
      } catch (error) {
        console.log("Error fetching Accounts", error);
      }
      setLoading(false);
    };
    fetchVoucherTypes();
    fetchAccounts();

  }, [Api]);

  useEffect(() => {
    setLoading(true);
    if (id) {
      const fetchReceipt = async () => {
        try {
          const Config = Authorization();
          const response = await axios.get(`${Api}/api/transactions/${id}`, Config);
          const paymentData = response.data.data; // Adjust based on your actual API response
          setFormData({
            vfcId: paymentData.vfcId?._id || "",
            accountId: paymentData.accountId?._id || "",
            voucherType: paymentData.voucherType || "",
            voucherNumber: paymentData.voucherNumber || "",
            partyDetails: paymentData.partyDetails || "",
            amount: paymentData.amount || "",
            description: paymentData.description || "",
            cashOrBank: paymentData.cashOrBank || "",
            date: paymentData.date ? paymentData.date.slice(0, 10) : "",
          });

        } catch (error) {
          console.error("Error fetching payment data", error);
        }
        setLoading(false);
      };

      fetchReceipt();
    }
  }, [id]);

  const validateForm = (formData) => {
    const newErrors = {};
    const requiredFields = [
      "vfcId",
      "accountId",
      "voucherType",
      "voucherNumber",
      "partyDetails",
      "amount",
      "description",
      "cashOrBank",
      "date",
    ];


    requiredFields.forEach((field) => {
      if (!formData[field]) newErrors[field] = `${field} is required`;
    });

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCancel = () => {
    setFormData(initialStage);
    navigate("/transaction/manage/payments");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        let response;
        if (id) {
          const Config = Authorization();
          response = await axios.put(`${Api}/api/transactions/${id}`, formData, Config);
        } else {
          const Config = Authorization();
          response = await axios.post(`${Api}/api/transactions`, formData, Config);
        }
        setSubmitMessage(response.data.message);
        toast.success("Payment saved successfully");
        navigate("/transaction/manage/payments");
      } catch (error) {
        console.error("Error saving payment", error);
        toast.error("Failed to save payment");
      }
    } else {
      toast.error("Please fix the form errors before submitting");
    }
  };

  return (
    <div>
      {loading && <Preloader loading={loading} />}
      <div className="page-header">
        <h3 className="page-title"> Edit Payments </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Edit Payments
            </li>
          </ol>
        </nav>
      </div>
      <Container>
        <h2 className="my-4">{id ? "Edit Payment" : "Add Payment"}</h2>
        {submitMessage && <Alert variant="success">{submitMessage}</Alert>}

        <>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <p className="card-description">SHG Registration Form</p>
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="vfcId">
                      <Form.Label>VFC Name</Form.Label>
                      <Form.Control
                        as="select"
                        name="vfcId"
                        value={formData.vfcId}
                        onChange={handleChange}
                      >
                        <option value="">Select VFC</option>
                        {vfcOptions.map((vfc) => (
                          <option key={vfc._id} value={vfc._id}>
                            {vfc.vfcName}
                          </option>
                        ))}
                      </Form.Control>
                      {errors.vfcId && (
                        <p className="text-danger">{errors.vfcId}</p>
                      )}
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="accountId">
                      <Form.Label>Account Name</Form.Label>
                      <Form.Control
                        as="select"
                        name="accountId"
                        value={formData.accountId}
                        onChange={handleChange}
                      >
                        <option value="">Select Account</option>
                        {accountOptions.map((acc) => (
                          <option key={acc._id} value={acc._id}>
                            {acc.accountName}
                          </option>
                        ))}
                      </Form.Control>
                      {errors.accountId && <p className="text-danger">{errors.accountId}</p>}
                    </Form.Group>

                    <Form.Group as={Col} controlId="voucherType">
                      <Form.Label>Voucher Type</Form.Label>
                      <Form.Control
                        as="select"
                        name="voucherType"
                        value={formData.voucherType}
                        onChange={handleChange}

                      >
                        <option value="">Select Voucher Head</option>
                        {voucherOptions.map((voucher) => (
                          <option
                            key={voucher.voucherType._id}
                            value={voucher.voucherType._id}
                          >
                            {voucher.voucherType.voucherName}
                          </option>
                        ))}
                      </Form.Control>
                      {errors.voucherType && <p className="text-danger">{errors.voucherType}</p>}
                    </Form.Group>


                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="voucherNumber">
                      <Form.Label>Voucher Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="voucherNumber"
                        value={formData.voucherNumber}
                        onChange={handleChange}
                      />
                      {errors.voucherNumber && (
                        <p className="text-danger">{errors.voucherNumber}</p>
                      )}
                    </Form.Group>
                    <Form.Group as={Col} controlId="partyDetails">
                      <Form.Label>Party Details</Form.Label>
                      <Form.Control
                        type="text"
                        name="partyDetails"
                        value={formData.partyDetails}
                        onChange={handleChange}
                      />
                      {errors.partyDetails && (
                        <p className="text-danger">{errors.partyDetails}</p>
                      )}
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="amount">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        type="number"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                      />
                      {errors.amount && (
                        <p className="text-danger">{errors.amount}</p>
                      )}
                    </Form.Group>
                    <Form.Group as={Col} controlId="description">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                      />
                      {errors.description && (
                        <p className="text-danger">{errors.description}</p>
                      )}
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="cashOrBank">
                      <Form.Label>Cash/Bank</Form.Label>
                      <Form.Control
                        type="text"
                        name="cashOrBank"
                        value={formData.cashOrBank}
                        onChange={handleChange}
                      />
                      {errors.cashOrBank && (
                        <p className="text-danger">{errors.cashOrBank}</p>
                      )}
                    </Form.Group>
                    <Form.Group as={Col} controlId="date">
                      <Form.Label>Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                      />
                      {errors.date && (
                        <p className="text-danger">{errors.date}</p>
                      )}
                    </Form.Group>
                  </Row>

                  <button
                    type="submit"
                    className="btn btn-outline-primary btn-icon-text mt-3"
                  >
                    <i className="mdi mdi-file-check btn-icon-prepend"></i>
                    {id ? "Update Payment" : "Add Payment"}
                  </button>
                  <button className="btn btn-light mt-3" onClick={handleCancel}>
                    Cancel
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </>
      </Container>
    </div>
  );
};

export default EditPayments;
